var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingPageLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M25.4151 36.7279L22.5867 39.5563C18.6814 43.4615 12.3498 43.4615 8.44456 39.5563C4.53931 35.651 4.53931 29.3194 8.44456 25.4141L11.273 22.5857M36.7288 25.4141L39.5573 22.5857C43.4625 18.6805 43.4625 12.3488 39.5573 8.44358C35.652 4.53834 29.3204 4.53834 25.4151 8.44358L22.5867 11.272M17.0009 30.9999L31.0009 16.9999",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageLink);
export default __webpack_public_path__ + "static/media/landing-page-link.28b7f45be68abcc452cde9c426a3f61e.svg";
export { ForwardRef as ReactComponent };